/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import firebase from 'firebase/app'
require('firebase/auth')
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'

let app = ''

const firebaseConfig = {
  apiKey: "AIzaSyCbKKTCg9OPvFyfUr5Gb5bhcNDpMMit_bI",
  authDomain: "car-dealer-728a6.firebaseapp.com",
  databaseURL: "https://car-dealer-728a6.firebaseio.com",
  projectId: "car-dealer-728a6",
  storageBucket: "car-dealer-728a6.appspot.com",
  messagingSenderId: "56769750634",
  appId: "1:56769750634:web:a9c36b86dec59c28cb0c13",
  measurementId: "G-1221KHPN7R"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

Vue.config.productionTip = false
Vue.use(ArgonDashboard)

firebase.auth().onAuthStateChanged(() => {
if (!app) {
  app = new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}
})
